import moment from 'moment';

const DATE_FORMAT = 'MMM Do YY';

export function formatDateRange(from, to) {
  return `${!from ? '' : moment(String(from)).format(DATE_FORMAT)} - ${
    !to ? '' : moment(String(to)).format(DATE_FORMAT)
  }`;
}
